import { FaUser } from "react-icons/fa";

const Navbar = () => {
  return (
    <nav className="w-full fixed top-0 z-50 bg-gradient-to-r from-red-900 to-red-800 shadow">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* Left Logo + Name */}
          <div className="flex items-center gap-2">
            <a href="/" className="text-white text-2xl font-bold">
              <img
                src="/logo192.webp"
                alt="logo"
                className="h-8 w-8 rounded-full bg-white p-1"
              />
            </a>
            <span className="text-xl font-bold text-pink-300">
              Sai <span className="text-white">Matka</span>
            </span>
          </div>

          {/* Right Login */}
          <div className="flex items-center gap-2 text-white cursor-pointer hover:text-gray-200">
            <FaUser />
            <a href="/download" className="text-white hover:text-gray-200">
              Login
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
